export default {
  list: { lazy: () => import('./NetworkTariff'), component: 'NetworkTariffList' },
  edit: { lazy: () => import('./NetworkTariff'), component: 'NetworkTariffEdit' },
  create: { lazy: () => import('./NetworkTariff'), component: 'NetworkTariffCreate' },
  options: {
    create: {
      title: 'Create Network Tariff',
      subtitle: null,
      breadCrumb: 'Create Network Tariff',
    },
    list: {
      title: 'All Network Tariffs',
      subtitle: null,
      breadCrumb: 'All Network Tariffs',
    },
    edit: {
      title: 'Edit Network Tariff',
      subtitle: null,
      breadCrumb: 'Edit Network Tariff',
    },
  },
}
